<template>
  <div>
    <div>
      <template v-for="route in router">
        <router-link
          exact
          class-active="active"
          class="menu__item"
          :key="route.id"
          v-if="validRole(route.rolesView)"
          :to="route.path"
          >{{ route.name }}</router-link
        >
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    router: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    validRole(roles) {
      return roles.includes(this.$store.state.login.roles[0]);
    },
  },
};
</script>
<style scoped>
.menu__item {
  margin: 0 9px;
  text-decoration: none;
  font-size: 1rem ;
  color:#959799 ;
}
.router-link-active,.router-link-exact-active, .menu__item:hover {
  color: #00843d;
}
</style>
